import router from "../router/index";

let base = {};
let timeout = null;
let throttleIf = true;
base.install = function(Vue, options) {
  // 回退到首页事件
  Vue.prototype.$_TiaoZhuangShouYe = function() {
    router.push("/Home");
    // let backlen = window.history.length - 1;
    // if (backlen > 3) {
    //     router.go(-(backlen - 1));
    // } else {
    //     router.replace('/Home')
    // }
  };
  // 成功提示框
  Vue.prototype.$_chenggongtishi = function(val) {
    this.$notify({
      title: val,
      dangerouslyUseHTMLString: true,
      message: ``,
      type: "success",
      offset: 10,
      duration: 2000,
      customClass: "tishikaung"
    });
  };
  // 失败提示框
  Vue.prototype.$_shibaitishi = function(val, num = 3000) {
    this.$notify({
      title: "失败",
      dangerouslyUseHTMLString: true,
      message: `<strong style="color:#F56C6C">${val}</strong>`,
      type: "error",
      offset: 10,
      duration: num,
      customClass: "tishikaung"
    });
  };
  // 防抖
  Vue.prototype.$_debounce = function(fn, canshu) {
    if (timeout) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(() => {
      fn(canshu);
      timeout = null;
    }, 1000);
  };
  // 节流
  Vue.prototype.$_throttle = function(fn, canshu) {
    if (throttleIf) {
      throttleIf = false;
      setTimeout(() => {
        throttleIf = true;
      }, 1500);
      fn(canshu);
    }
  };
  // 加法
  Vue.prototype.$_jia = function(num1, num2) {
    num1 = num1 ? num1 : 0;
    num2 = num2 ? num2 : 0;
    var baseNum, baseNum1, baseNum2;
    try {
      baseNum1 = num1.toString().split(".")[1].length;
    } catch (e) {
      baseNum1 = 0;
    }
    try {
      baseNum2 = num2.toString().split(".")[1].length;
    } catch (e) {
      baseNum2 = 0;
    }

    baseNum = Math.pow(10, Math.max(baseNum1, baseNum2));
    return (Math.floor(num1 * baseNum) + Math.floor(num2 * baseNum)) / baseNum;
  };
  // 减法
  Vue.prototype.$_jian = function(num1, num2) {
    num1 = num1 ? num1 : 0;
    num2 = num2 ? num2 : 0;
    var baseNum, baseNum1, baseNum2;
    try {
      baseNum1 = num1.toString().split(".")[1].length;
    } catch (e) {
      baseNum1 = 0;
    }
    try {
      baseNum2 = num2.toString().split(".")[1].length;
    } catch (e) {
      baseNum2 = 0;
    }
    baseNum = Math.pow(10, Math.max(baseNum1, baseNum2));
    return (Math.floor(num1 * baseNum) - Math.floor(num2 * baseNum)) / baseNum;
  };
  // 乘法
  Vue.prototype.$_cheng = function(num1, num2) {
    num1 = num1 ? num1 : 0;
    num2 = num2 ? num2 : 0;
    var baseNum = 0;
    try {
      baseNum += num1.toString().split(".")[1].length;
    } catch (e) {}
    try {
      baseNum += num2.toString().split(".")[1].length;
    } catch (e) {}
    return (
      (Number(num1.toString().replace(".", "")) *
        Number(num2.toString().replace(".", ""))) /
      Math.pow(10, baseNum)
    );
  };
  // 除法
  Vue.prototype.$_chu = function(arg1, arg2) {
    arg1 = arg1 ? arg1 : 0;
    arg2 = arg2 ? arg2 : 1;
    var t1 = 0,
      t2 = 0,
      r1,
      r2;
    try {
      t1 = arg1.toString().split(".")[1].length;
    } catch (e) {}
    try {
      t2 = arg2.toString().split(".")[1].length;
    } catch (e) {}
    r1 = Number(arg1.toString().replace(".", ""));
    r2 = Number(arg2.toString().replace(".", ""));
    let aa = (r1 / r2) * Math.pow(10, t2 - t1);
    return aa;
  };
  // 复制
  Vue.prototype.$_fuzhi = function(val, str) {
    let input = document.createElement("input");
    input.setAttribute("value", val);
    document.body.appendChild(input);
    input.select();
    document.execCommand("copy");
    document.body.removeChild(input);
    this.$_chenggongtishi(str || "复制成功");
  };
};

export default base;



// WEBPACK FOOTER //
// ./src/base/base.js